import { AbstractHttpService, RequestMethod } from './abstracts/abstract-http.service';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { UserEmailing } from '@shared/interfaces/automation/user-emailing';
import { UserDeleteEmailing } from '@shared/interfaces/automation/user-delete-emailing';

@Injectable({
  providedIn: 'root',
})
export class AutomationService extends AbstractHttpService {
  constructor() {
    super('');
    this.url = 'https://hook.eu2.make.com';
  }

  addUserToEmailing(jobId: string, userEmailing: UserEmailing) {
    return this.getWebhook<UserEmailing>(jobId, { ...userEmailing });
  }

  removeUserToEmailing(jobId: string, userDeleteEmailing: UserDeleteEmailing) {
    return this.getWebhook<{
      email: string;
    }>(jobId, {
      ...userDeleteEmailing,
    });
  }

  override post<T>(path: string, item?: unknown): Observable<T> {
    const url = `${this.url}${path ? `/${path}` : ''}`;
    return this.http.post<T>(url, item).pipe(
      tap((response) => {
        this.logger({ method: RequestMethod.POST, url }, response);
      })
    );
  }

  protected getWebhook<T>(webhookId: string, item: T): Observable<void> {
    return this.post<void>(webhookId, item);
  }
}
